/**
 * @generated SignedSource<<58d096299df85337b57ab691e0dca30d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmailFormDataWrapper_root$data = {
  readonly docTemplates: {
    readonly " $fragmentSpreads": FragmentRefs<"useGetDefaultRelayTemplate">;
  } | null;
  readonly me: {
    readonly id: string;
    readonly nylasAccount: {
      readonly id: string;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"EmailForm_me">;
  } | null;
  readonly " $fragmentType": "EmailFormDataWrapper_root";
};
export type EmailFormDataWrapper_root$key = {
  readonly " $data"?: EmailFormDataWrapper_root$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmailFormDataWrapper_root">;
};

import EmailFormDataWrapperRefetchQuery_graphql from './EmailFormDataWrapperRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": EmailFormDataWrapperRefetchQuery_graphql
    }
  },
  "name": "EmailFormDataWrapper_root",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmailForm_me"
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "NylasAccount",
          "kind": "LinkedField",
          "name": "nylasAccount",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        }
      ],
      "concreteType": "DocTemplateConnection",
      "kind": "LinkedField",
      "name": "docTemplates",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useGetDefaultRelayTemplate"
        }
      ],
      "storageKey": "docTemplates(first:100)"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "46fb8117222dc133e6955cbc87134551";

export default node;
